var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51983 0.300892C2.92759 1.66469 -0.794079 7.2201 0.14486 12.8024C0.703088 16.1201 2.32642 18.3748 8.76729 24.7776L11.0029 27L13.2384 24.7776C19.7178 18.3365 21.3706 16.0161 21.8786 12.6468C23.0211 5.06963 15.9109 -1.50155 8.51983 0.300892ZM13.6882 3.63948C20.0833 5.90907 20.5855 14.9228 14.4965 18.1501C13.4323 18.7141 13.1176 18.77 11.0029 18.77C8.88815 18.77 8.5734 18.7141 7.50918 18.1501C2.73923 15.6218 1.71396 9.29174 5.46219 5.51206C7.62937 3.32686 10.784 2.60856 13.6882 3.63948Z",
    fill: "#0000FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlue);
export default __webpack_public_path__ + "static/media/marker-blue.105688db67df92cc2f68ac038b005a5c.svg";
export { ForwardRef as ReactComponent };